module.exports = __webpack_public_path__ + "img/like_blank.b7ddab60.png";